import onetime from "@-/com.npmjs.onetime";
import type { DeadlineExceededError } from "#deadline-exceeded-error";

type DeadlineListener = (error: DeadlineExceededError) => void;

const getListeners = onetime(() => new Set<DeadlineListener>());

/**
 * Observe every enforced deadline. The app registers its crash reporter here once; this package
 * stays dependency-free so the database engine, sync client and reporter can all build on it.
 * Returns the unsubscribe function.
 */
export function onDeadlineExceeded(listener: DeadlineListener): () => void {
  getListeners().add(listener);
  return () => {
    getListeners().delete(listener);
  };
}

export function notifyDeadlineExceeded(error: DeadlineExceededError): void {
  for (const listener of getListeners()) {
    try {
      listener(error);
    } catch {
      // Reporting a hang must never turn into a second failure.
    }
  }
}
